import { ActionTypes } from "../constants/action-types"

const initialState = {
    testimonials: []
}

const fetchTestimonials = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.FETCH_TESTIMONIALS : return {...state, 
            testimonials: payload}           
        default: return state;
    }
    
}


export default fetchTestimonials;